export { default as PrivacyPage } from './ui/PrivacyPage';
